<SettingsAddUserModal
    :is_open="is_open"
    :is_saving="is_saving"
    :form_error="form_error"
    :role_options="role_options"
    :property_options="property_options"
    :is_loading_roles="is_loading_roles"
    :is_loading_properties="is_loading_properties"
    @close="close_modal"
    @dismiss-error="form_error = ''"
    @submit="save_user"
/>
